<template lang="pug">
div
  v-slide-y-transition
    v-app(:class="{['i'+randomImg]:true}")
      wf-toolbar(v-if="!isLoginView")
      v-content
        router-view
      wf-snackbar
      wf-confirm
  transition(name="fade")
    div.loader-wrapper(v-if="!appLoaded && !isLoginView")
      div.loader
</template>

<script>
import { mapGetters } from 'vuex'

import Toolbar from '@/components/utils/Toolbar'
import Snackbar from '@/components/utils/Snackbar'
import Confirm from '@/components/utils/Confirm'

let intr = null

export default {
  name: 'App',

  components: {
    'wf-toolbar': Toolbar,
    'wf-snackbar': Snackbar,
    'wf-confirm': Confirm,
  },
  data() {
    return {
      randomImg: 0,
    }
  },
  computed: {
    ...mapGetters({
      appLoaded: 'tools/appLoaded',
    }),
    isLoginView() {
      return this.$route.path === '/login'
    },
  },
  created() {
    this.getRandomImg()
    intr = setInterval(() => {
      this.getRandomImg()
    }, 600000)
  },
  beforeDestroy() {
    clearInterval(intr)
  },
  methods: {
    getRandomImg() {
      this.randomImg = 1 + Math.floor(Math.random() * 5)
    },
  },
}
</script>
<style lang="stylus">
.font-tight
  letter-spacing -0.1px

.transparent
  background-color: transparent !important
  border-color transparent !important

.v-text-field--box>.v-input__control>.v-input__slot:before
  border-width: thin 0 0
</style>



// WEBPACK FOOTER //
// src/App.vue